import app from 'flarum/forum/app';
import IndexPageHero from 'flarum/newvigation/components/IndexPageHero';
import type Tag from 'flarum/tags/common/models/Tag';

export default function changeIndexPageTitle() {
	/**
	 * @TODO: refactor this to use the regular `extend` method. This is a non-standard hack!
	 */
	Object.defineProperty(IndexPageHero.prototype, 'title', {
		get() {
			const currentRoute = app.current.get('routeName');
			const currentTag: Tag = app.current.get('tag');

			if (currentRoute === 'index' || (currentRoute === 'tag' && currentTag?.slug() !== 'leserunden')) {
				return app.translator.trans('glowingblue-orell-thalia-common.forum.index.title');
			}

			return this.attrs.title || app.translator.trans('core.forum.index.all_discussions_link');
		},
	});
}
